<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ "add" }}</v-icon> {{ "Detalle comsión" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex xs4 >
								<p><strong>CITE de la comisión:</strong></p>
							</v-flex> -->
              <v-flex xs12 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>CITE de la comisión:</strong> {{ this.form.cite }}
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <strong>Objetivo de la comisión:</strong>
                  <p>{{ this.form.objetivo }}</p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Fecha salida (viaje):</strong>
                    {{
                      this.form.fecha_salida
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                    <v-icon>date_range</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Fecha retorno (viaje):</strong>
                    {{
                      this.form.fecha_retorno
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                    <v-icon>date_range</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora salida (viaje):</strong>
                    {{ this.form.hora_salida_viaje }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora retorno (viaje):</strong>
                    {{ this.form.hora_retorno_viaje }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora salida tolerancia:</strong>
                    {{ this.form.hora_salida_tolera }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora retorno tolerancia:</strong>
                    {{ this.form.hora_retorno_tolera }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>
            <small
              >* El sistema otorga dos horas de tolerancia antes y despues de
              los horarios del viaje</small
            >
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()"> <v-icon>cancel</v-icon>Cerrar </v-btn>
          
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {
        cite: "",
        objetivo: "",
        fecha_salida: "",
        fecha_retorno: "",
        hora_salida: "",
        hora_retorno: "",
        hora_salida_tolera: "",
        hora_retorno_tolera: ""
      },
      valid: false,
      loading: false,
      id_detalle: -1
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerDetalleRegistro", async item => {
      (this.id_detalle=parseInt(item)),
        (this.dialog = true);
        await this.cargarForm()
    });
  },
  methods: {
   
    async cargarForm() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"SELECT id,id_persona,cite, objetivo,fecha_salida,fecha_retorno,hora_salida_viaje,hora_retorno_viaje,hora_salida_tolera,hora_retorno_tolera FROM CONTROL.comision WHERE id=${this.id_detalle}"){
					respuesta
				}
				}
			`
        });
        respuesta = respuesta.runQuery.respuesta[0];
        this.form = respuesta;
      } catch (error) {}
    },
    close() {
      this.form = {
        cite: "",
        objetivo: "",
        fecha_salida: "",
        fecha_retorno: "",
        hora_salida: "",
        hora_retorno: "",
        hora_salida_tolera: "",
        hora_retorno_tolera: ""
      };
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      
      
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/comision_viaje/dialogs/VerDetalleRegistro.vue